import React from 'react'
import PropTypes from 'prop-types'

import './slideitem.scss'

class SlideItem extends React.PureComponent {

  static propTypes = {
    item: PropTypes.string.isRequired,
    arrowNext: PropTypes.func.isRequired,
    arrowPrev: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.ref = React.createRef()
  }

  componentDidMount() {
    const {
      arrowNext,
      arrowPrev,
    } = this.props
    const node = this.ref.current
    const prev = node.querySelector('.btn-prev')
    const next = node.querySelector('.btn-next')
    prev.addEventListener('click', arrowPrev)
    next.addEventListener('click', arrowNext)

    prev.addEventListener('keypress', function (e) {
      if (
          e.type === "keydown" &&
          e.key !== "Enter" &&
          e.key !== " "
      ) {
        return
      }
      arrowPrev()
    })

    next.addEventListener('keypress', function (e) {
      if (
          e.type === "keydown" &&
          e.key !== "Enter" &&
          e.key !== " "
      ) {
        return
      }
      arrowNext()
    })

  }


  render() {
    const {
      item,
    } = this.props

    return (
      <div dangerouslySetInnerHTML={{ __html: item }} ref={this.ref} />
    )
  }
}

export default SlideItem
